import React, { useState, useEffect } from 'react';
import './Comandos.css';
import Form from 'react-bootstrap/Form';
import ModalConfirmacionGeneral from './ModalConfirmacionGeneral';
import ModalPersonalizadoGeneral from './ModalPersonalizadoGeneral';
import { Modal } from 'react-bootstrap';
import { GiWindsock, GiBroom, GiHand } from 'react-icons/gi';
import { BsSnow3, BsArrowCounterclockwise } from 'react-icons/bs';
import { FaChartPie } from 'react-icons/fa';
import { MdOutlineMotionPhotosAuto } from 'react-icons/md';
import {TbLetterA} from 'react-icons/tb';

function Comandos() {
    // *********************************************************************************************************************************************************************************
    var comandos = (JSON.parse(sessionStorage.getItem("commands")));

    var [enviarLista, setEnviarLista] = useState('');
    var [enviarDevice, setEnviarDevice] = useState();
    const [abrirModal, setAbrirModal] = useState(false);
    const [abrirModalPers, setAbrirModalPers] = useState(false);

    //Modales de confirmación de envío de comandos
    const childToParent = (abrirModal) => {
        setAbrirModal(abrirModal)
    }

    const childToParentPers = (abrirModalPers) => {
        setAbrirModalPers(abrirModalPers)
    }
    
    /**Ver que comandos hay disponibles y mostrarlos en la pantalla */
    
    const [displayNCU,setDisplayNCU] = useState('none');//Si hay por ncu
    const [displayGroups,setDisplayGroups] = useState('none');//Si hay por Grupos
    const [displayTCU,setDisplayTCU] = useState('none');//Si hay por TCU individual

    const [displayInvOn,setDisplayInvOn] = useState('none');    
    const [displayInvOff,setDisplayInvOff] = useState('none');
    const [displayNCUResetAlarm,setDisplayNCUResetAlarm] = useState('none');
    const [displayGroupsWind,setDisplayGroupsWind] = useState('none');
    const [displayGroupsSnow,setDisplayGroupsSnow] = useState('none');
    const [displayGroupsClean,setDisplayGroupsClean] = useState('none');
    const [displayGroupsPerso,setDisplayGroupsPerso] = useState('none');
    const [displayGroupsReset,setDisplayGroupsReset] = useState('none');
    const [displayGroupsAuto,setDisplayGroupsAuto] = useState('none');
    const [displayGroupsManual,setDisplayGroupsManual] = useState('none');
    const [displayTCUWind,setDisplayTCUWind] = useState('none');
    const [displayTCUSnow,setDisplayTCUSnow] = useState('none');
    const [displayTCUClean,setDisplayTCUClean] = useState('none');
    const [displayTCUPerso,setDisplayTCUPerso] = useState('none');
    const [displayTCUReset,setDisplayTCUReset] = useState('none');
    const [displayTCUResetAlarm,setDisplayTCUResetAlarm] = useState('none');
    const [displayTCUAuto,setDisplayTCUAuto] = useState('none');
    const [displayTCUManual,setDisplayTCUManual] = useState('none');

    useEffect(() => {
        for(let i = 0;i<comandos.length;i++) {

            switch(comandos[i].IdDevice){
                case 2://Inversor
                    switch(comandos[i].Command){
                        case 'ON':
                            if(displayInvOn === 'none'){
                                setDisplayInvOn('');
                            }
                        break;
                        case 'OFF':
                            if(displayInvOff ==='none'){
                                setDisplayInvOff('');
                            }
                        break;
                        default:
                    }
                break;
                
                case 3://Tracker

                    if(displayTCU === 'none'){//Para que no haga por cada comando 
                        setDisplayTCU(''); //un set de este display
                    }

                    switch(comandos[i].Command){
                        case 'WIND':
                            if(displayTCUWind === 'none'){
                                setDisplayTCUWind('');
                            }
                        break;
                        case 'SNOW':
                            if(displayTCUSnow ==='none'){
                                setDisplayTCUSnow('');
                            }
                        break;
                        case 'CLEAN':
                            if(displayTCUClean === 'none'){
                                setDisplayTCUClean('');
                            }
                        break;
                        case 'PERSO':
                            if(displayTCUPerso ==='none'){
                                setDisplayTCUPerso('');
                            }
                        break;
                        case 'RESET':
                            if(displayTCUReset === 'none'){
                                setDisplayTCUReset('');
                            }
                        break;
                        case 'RESET_ALARM':
                            if(displayTCUResetAlarm ==='none'){
                                setDisplayTCUResetAlarm('');
                            }
                        break;
                        case 'AUTO':
                            if(displayTCUAuto === 'none'){
                                setDisplayTCUAuto('');
                            }
                        break;
                        case 'MANUAL':
                            if(displayTCUManual ==='none'){
                                setDisplayTCUManual('');
                            }
                        break;
                        default:
                    }
                break;

                case 4://NCU
                    if(displayNCU === 'none'){//Para que no haga por cada comando 
                        setDisplayNCU(''); //un set de este display
                    }

                    switch(comandos[i].Command){
                        case 'RESET_ALARM':
                            if(displayNCUResetAlarm ==='none'){
                                setDisplayNCUResetAlarm('');
                            }
                        break;
                        default:
                    }
                break;

                case 11://Grupos 
                    if(displayGroups === 'none'){//Para que no haga por cada comando 
                        setDisplayGroups(''); //un set de este display
                    }

                    switch(comandos[i].Command){
                        case 'WIND':
                            if(displayGroupsWind === 'none'){
                                setDisplayGroupsWind('');
                            }
                        break;
                        case 'SNOW':
                            if(displayGroupsSnow ==='none'){
                                setDisplayGroupsSnow('');
                            }
                        break;
                        case 'CLEAN':
                            if(displayGroupsClean === 'none'){
                                setDisplayGroupsClean('');
                            }
                        break;
                        case 'PERSO':
                            if(displayGroupsPerso ==='none'){
                                setDisplayGroupsPerso('');
                            }
                        break;
                        case 'RESET':
                            if(displayGroupsReset === 'none'){
                                setDisplayGroupsReset('');
                            }
                        break;
                        case 'AUTO':
                            if(displayGroupsAuto === 'none'){
                                setDisplayGroupsAuto('');
                            }
                        break;
                        case 'MANUAL':
                            if(displayGroupsManual ==='none'){
                                setDisplayGroupsManual('');
                            }
                        break;
                        default:
                    }
                break;
                default:
            
            }
        }
    }, []);



    // -------------------------------------------------------------------------- CT ---------------------------------------------------------------------------------------------------

    const CT = (JSON.parse(sessionStorage.getItem("CTConfiguration")));
    var [htmlCT, setHtmlCT] = useState(<></>);
    var [textoBotonCT, setTextoBotonCT] = useState('Marcar todos');
    var [comandoEnviado, setComandoEnviado] = useState('');
    var [deviceCT, setDeviceCT] = useState();
    var [listaCT, setListaCT] = useState('');
    var [htmlBotonesCT, setHtmlBotonesCT] = useState(<></>);

    // Marcar y/o desmarcar todos los cts de la lista

    function MarcarTodosCT() {
        if (textoBotonCT === 'Marcar todos') {
            setTextoBotonCT('Desmarcar todos');
            cambiarTodoCT(true);
        } else {
            setTextoBotonCT('Marcar todos');
            cambiarTodoCT(false);
        }
    };

    const cambiarTodoCT = (value) => {
        for (let i = 0; i < CT.length; i++) {
            document.getElementById(CT[i].id).checked = value;
        }
        actualizarStringCT();
    };

    // Actualizar string de la consulta a la API según qué CTS están marcados y marca los inversores
    const actualizarStringCT = () => {
        var str = '';
        for (let i = 0; i < CT.length; i++) {
            if (document.getElementById(CT[i].id).checked === true) {
                str += CT[i].id + ',';
                MarcarTodosINVCT(CT[i].id,true);
            }else{
                MarcarTodosINVCT(CT[i].id,false)
            }
        }
        
        str = str.slice(0, -1);
        setListaCT(str);
    }

    //Marcar y desmarcar inversores dependiendo del CT
    function MarcarTodosINVCT(id,marcado) {
        if(marcado === true){
            for (let i = 0; i < INV.length; i++) {
                if (INV[i].idCT === id) {
                    document.getElementById(INV[i].id + CT.length).checked = true;
                }
            }
            setTextoBotonINV('Desmarcar todos');
        }else{
            for (let i = 0; i < INV.length; i++) {
                if (INV[i].idCT === id) {
                    document.getElementById(INV[i].id + CT.length).checked = false;
                }
            }
            setTextoBotonINV('Marcar todos');
        }
        actualizarStringInv();
    };

    
    

    useEffect(() => {
        htmlCT = CT.map((datoCT, index) => {
            const { id, idDevice, idCT, name } = datoCT;
            setDeviceCT(idDevice);
            return (
                <div key={idCT} className='col-xl-1 col-lg-2 col-sm-3 col-4'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={idCT} onClick={() => { actualizarStringCT(id) }} />
                        <label className="form-check-label" style={{width:"fit-content"}} htmlFor={idCT}>{name}</label>
                    </div>
                </div>
            );
        })
        setHtmlCT(htmlCT);
    }, []);


    // *********************************************************************************************************************************************************************************
    // -------------------------------------------------------------------------- INV --------------------------------------------------------------------------------------------------

    const INV = (JSON.parse(sessionStorage.getItem("InverterConfiguration")));
    var [htmlINV, setHtmlINV] = useState(<></>);
    var [textoBotonINV, setTextoBotonINV] = useState('Marcar todos');
    var [listaInv, setListaInv] = useState('');
    var [htmlBotonesINV, setHtmlBotonesINV] = useState(<></>);
    var [deviceINV, setDeviceINV] = useState();

    useEffect(() => {
        htmlINV = INV.map((datoINV, index) => {
            const { id, idDevice, idSolarFarm, idCT, idInverter, name } = datoINV;
            setDeviceINV(idDevice);
            return (
                <div className='col-xl-1 col-lg-2 col-sm-3 col-4' key={datoINV.id}>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={id + CT.length} onClick={() => { actualizarStringInv(id) }} /> 
                        <label className="form-check-label" htmlFor={id + CT.length}>{name}</label>
                    </div>
                </div>
            );
        })
        setHtmlINV(htmlINV);
    }, []);

    //Habilitar y deshabilitar botones stop y start dependiendo de si hay alguna casilla marcada.
    useEffect(() => {
        var htmlBotInv;
        var events,colorStart,colorStop;

        if (listaInv === ''){
            events = "none";//Deshabilitar eventos (onClick)
            colorStart = "#719E71";
            colorStop ="#B98C8C";
        } else{
            events="auto";//Habilitar eventos(onClick)
            colorStart = "";
            colorStop ="";
        }
        htmlBotInv = <>
            <div className='col-auto' style={{display:displayInvOn }}>
                <a id='a-inv-command-screen-start' style={{ pointerEvents: events, backgroundColor: colorStart}} onClick={() => { setAbrirModal(true); setComandoEnviado('ON'); setEnviarDevice(deviceINV); setEnviarLista(listaInv) }}>START</a>
            </div>
            <div className='col-auto' style={{display:displayInvOff }}>
                <a id='a-inv-command-screen-stop' style={{ pointerEvents: events, backgroundColor: colorStop}} onClick={() => { setAbrirModal(true); setComandoEnviado('OFF'); setEnviarDevice(deviceINV); setEnviarLista(listaInv) }}>STOP</a>
            </div>
        </>
        
        setHtmlBotonesINV(htmlBotInv);
    }, [listaInv,displayInvOn,displayInvOff]);


    // Marcar y/o desmarcar todos los inv de la lista
    
    function MarcarTodosINV() {
        if (textoBotonINV === 'Marcar todos') {
            setTextoBotonINV('Desmarcar todos');
            cambiarTodoINV(true);
        } else {
            setTextoBotonINV('Marcar todos');
            cambiarTodoINV(false);
        }
    };

    const cambiarTodoINV = (value) => {
        for (let i = 0; i < INV.length; i++) {
            document.getElementById(INV[i].id + CT.length).checked = value;
        }
        actualizarStringInv();
    };

    // Actualizar string de la consulta a la API según qué INV están marcados
    const actualizarStringInv = () => {
        var str = '';

        for (let i = 0; i < INV.length; i++) {
            if (document.getElementById(INV[i].id + CT.length).checked === true) {
                str += INV[i].id + ',';
            }
        }
        str = str.slice(0, -1);
        setListaInv(str);

    };


    // *********************************************************************************************************************************************************************************
    // -------------------------------------------------------------------------- TCU --------------------------------------------------------------------------------------------------
    const TCU = (JSON.parse(sessionStorage.getItem("TrackerConfiguration")));
    var [htmlTCU, setHtmlTCU] = useState(<></>);
    var [textoBotonTCU, setTextoBotonTCU] = useState('Marcar todos');
    var [listaTCU, setListaTCU] = useState('');
    var [deviceTCU, setDeviceTCU] = useState();
    var [htmlBotonesTCU, setHtmlBotonesTCU] = useState(<></>);
    var size_ico = 20;


    useEffect(() => {
        htmlTCU = TCU.map((datoTCU, index) => {
            const { id, idDevice, name } = datoTCU;
            setDeviceTCU(idDevice);
            return (
                <div key={id + CT.length + INV.length} className='col-xl-1 col-lg-2 col-sm-3 col-4'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={id + CT.length + INV.length} onClick={() => { actualizarStringTCU(id) }}/*disabled*/ />
                        <label className="form-check-label" htmlFor={id + CT.length + INV.length}>{name}</label>
                    </div>
                </div>
            );
        })
        setHtmlTCU(htmlTCU);
    }, []);


    // Actualizar string de la consulta a la API según qué TCU están marcados
    const actualizarStringTCU = () => {
        var str = '';
        for (let i = 0; i < TCU.length; i++) {
            if (document.getElementById(TCU[i].id + CT.length + INV.length).checked === true) {
                str += TCU[i].id + ',';
            }
        }
        str = str.slice(0, -1);
        setListaTCU(str);
    }


    const cambiarTodoTCU = (value) => {
        for (let i = 0; i < TCU.length; i++) {
            document.getElementById(TCU[i].id + CT.length + INV.length).checked = value;
        }
        actualizarStringTCU();
    }

    function MarcarTodosTCU() {
        if (textoBotonTCU === 'Marcar todos') {
            setTextoBotonTCU('Desmarcar todos');
            cambiarTodoTCU(true);
        } else {
            setTextoBotonTCU('Marcar todos');
            cambiarTodoTCU(false);
        }
    }

    //Habilitar y deshabilitar botones stop y start dependiendo de si hay alguna casilla marcada.
    useEffect(() => {
        var htmlBotTcu;
        var events,color;
        if (listaTCU === ''){
            events = "none";
            color = "lightgrey"
        } else{
            events="auto";
            color="";
        }
            htmlBotTcu = <>

                <div className='col-auto' style={{display:displayTCUWind}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('WIND'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }} ><GiWindsock size={size_ico} title={"Posición Viento"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUSnow}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('SNOW'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><BsSnow3 size={size_ico} title={"Posición Nieve"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUClean}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('CLEAN'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><GiBroom size={size_ico} title={"Posición Limpieza"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUPerso}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModalPers(true); setComandoEnviado('PERSO'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}> <FaChartPie size={size_ico} title={"Posición Personalizada"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUReset}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('RESET'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><BsArrowCounterclockwise size={size_ico} title={"Reset Pos"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUAuto}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('AUTO'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><TbLetterA size={size_ico} title={"Automático"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUManual}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('MANUAL'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><GiHand size={size_ico} title={"Manual"} /></a>
                </div>
                <div className='col-auto' style={{display:displayTCUResetAlarm}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('RESET_ALARM'); setEnviarDevice(deviceTCU); setEnviarLista(listaTCU) }}><MdOutlineMotionPhotosAuto size={size_ico} title={"Reset Alarmas"} /></a>
                </div>
            </>
        //}
        setHtmlBotonesTCU(htmlBotTcu);
    }, [listaTCU,displayTCU,displayTCUWind,displayTCUSnow,displayTCUClean,displayTCUPerso,displayTCUReset,displayTCUAuto,displayTCUManual,displayTCUResetAlarm]);



    // *********************************************************************************************************************************************************************************
    // -------------------------------------------------------------------------- NCU --------------------------------------------------------------------------------------------------

    const NCU = (JSON.parse(sessionStorage.getItem("NCUConfiguration")));
    var [htmlNCU, setHtmlNCU] = useState(<></>);
    var [textoBotonNCU, setTextoBotonNCU] = useState('Marcar todos');
    var [deviceNCU, setDeviceNCU] = useState();
    var [listaNCU, setListaNCU] = useState('');
    var [htmlBotonesNCU, setHtmlBotonesNCU] = useState(<></>);

    // Marcar y/o desmarcar todos los cts de la lista

    function MarcarTodosNCU() {
        if (textoBotonNCU === 'Marcar todos') {
            setTextoBotonNCU('Desmarcar todos');
            cambiarTodoNCU(true);
        } else {
            setTextoBotonNCU('Marcar todos');
            cambiarTodoNCU(false);
        }
    };

    const cambiarTodoNCU = (value) => {
        for (let i = 0; i < NCU.length; i++) {
            document.getElementById(NCU[i].id + CT.length+INV.length+TCU.length).checked = value;
        }
        actualizarStringNCU();
    };

    // Actualizar string de la consulta a la API según qué NCU están marcados y marca los grupos
    const actualizarStringNCU = () => {
        var str = '';
        for (let i = 0; i < NCU.length; i++) {
            if (document.getElementById(NCU[i].id + CT.length+INV.length+TCU.length).checked === true) {
                str += NCU[i].id + ',';
                MarcarTodosGrupoNCU(NCU[i].id,true);
            }else{
                MarcarTodosGrupoNCU(NCU[i].id,false)
            }
        }
        
        str = str.slice(0, -1);
        setListaNCU(str);
    }

    //Marcar y desmarcar grupo dependiendo del NCU
    function MarcarTodosGrupoNCU(id,marcado) {
        if(marcado === true){
            for (let i = 0; i < Groups.length; i++) {
                if (Groups[i].idNCU === id) {
                    document.getElementById(Groups[i].id + CT.length+INV.length+TCU.length+NCU.length).checked = true;
                }
            }
            setTextoBotonGroups('Desmarcar todos');
        }else{
            for (let i = 0; i < Groups.length; i++) {
                if (Groups[i].idNCU === id) {
                    document.getElementById(Groups[i].id + CT.length+INV.length+TCU.length+NCU.length).checked = false;
                }
            }
            setTextoBotonGroups('Marcar todos');
        }
        actualizarStringGroups();
    };

    

    //Habilitar y deshabilitar boton de reset alamarms dependiendo de si hay casillas marcadas
    useEffect(() => {
        var htmlBotNcu;
        var events,color;
        if (listaNCU === ''){
            events = "none";
            color = "lightgrey"
        } else{
            events="auto";
            color="";
        }
            htmlBotNcu = <>

                <div className='col-auto' style={{display:displayNCUResetAlarm}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('RESET_ALARM'); setEnviarDevice(deviceNCU); setEnviarLista(listaNCU);}}><MdOutlineMotionPhotosAuto size={size_ico} title={"Reset Alarmas"} /></a>
                </div>
            </>
        //}
        setHtmlBotonesNCU(htmlBotNcu);
    }, [listaNCU, displayNCUResetAlarm]);

    useEffect(() => {
        htmlNCU = NCU.map((datoNCU, index) => {
            const { id, idDevice, idNCU, nameNCU } = datoNCU;
            
            setDeviceNCU(idDevice);
            
            return (
                <div key={idNCU} className='col-xl-1 col-lg-2 col-sm-3 col-4'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={id + CT.length + INV.length+TCU.length} onClick={() => { actualizarStringNCU(id) }} />
                        <label className="form-check-label" htmlFor={id + CT.length + INV.length+TCU.length}>{nameNCU}</label>
                    </div>
                </div>
            );
        })
        setHtmlNCU(htmlNCU);
    }, []);

// *********************************************************************************************************************************************************************************
    // -------------------------------------------------------------------------- GRUPOS NCU----------------------------------------------------------------------------------------

    const Groups = (JSON.parse(sessionStorage.getItem("NCUGroups")));
    var [htmlGroups, setHtmlGroups] = useState(<></>);
    var [textoBotonGroups, setTextoBotonGroups] = useState('Marcar todos');
    var [listaGroups, setListaGroups] = useState('');
    var [htmlBotonesGroups, setHtmlBotonesGroups] = useState(<></>);
    var [deviceGroups, setDeviceGroups] = useState();

    useEffect(() => {
        htmlGroups = Groups.map((datoGroups, index) => {
            const { id, idDevice, name } = datoGroups;
            setDeviceGroups(idDevice);
            return (
                <div className='col-xl-1 col-lg-2 col-sm-3 col-4' key={datoGroups.id}>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={id + CT.length + INV.length+TCU.length+NCU.length} onClick={() => { actualizarStringGroups(id) }} /> 
                        <label className="form-check-label" htmlFor={id + CT.length + INV.length+TCU.length+NCU.length}>{name}</label>
                    </div>
                </div>
            );
        })
        setHtmlGroups(htmlGroups);
    }, []);

    //Habilitar y deshabilitar botones dependiendo de si hay alguna casilla marcada.
    useEffect(() => {
        var htmlBotGroup;
        var events,color;
        if (listaGroups === ''){
            events = "none";
            color = "lightgrey"
        } else{
            events="auto";
            color="";
        }
        htmlBotGroup = <>

                <div className='col-auto' style={{display:displayGroupsWind}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('WIND'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }} ><GiWindsock size={size_ico} title={"Posición Viento"} /></a>
                    
                </div>
                <div className='col-auto' style={{display:displayGroupsSnow}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('SNOW'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}><BsSnow3 size={size_ico} title={"Posición Nieve"} /></a>
                </div>
                <div className='col-auto' style={{display:displayGroupsClean}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('CLEAN'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}><GiBroom size={size_ico} title={"Posición Limpieza"} /></a>
                    
                </div>
                <div className='col-auto' style={{display:displayGroupsPerso}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModalPers(true); setComandoEnviado('PERSO'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}> <FaChartPie size={size_ico} title={"Posición Personalizada"} /></a>
                </div>
                <div className='col-auto' style={{display:displayGroupsReset}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('RESET'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}><BsArrowCounterclockwise size={size_ico} title={"Reset Pos"} /></a>
                </div>
                <div className='col-auto' style={{display:displayGroupsAuto}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('AUTO'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}><TbLetterA size={size_ico} title={"Automático"} /></a>
                </div>
                <div className='col-auto' style={{display:displayGroupsManual}}>
                    <a className='a-tcu-command-screen' style={{ pointerEvents:events,backgroundColor:color}} onClick={() => { setAbrirModal(true); setComandoEnviado('MANUAL'); setEnviarDevice(deviceGroups); setEnviarLista(listaGroups) }}><GiHand size={size_ico} title={"Manual"} /></a>
                </div>
            </>
        //}
        setHtmlBotonesGroups(htmlBotGroup);
    }, [listaGroups,displayGroupsWind,displayGroupsSnow,displayGroups,displayGroupsClean,displayGroupsPerso,displayGroupsReset,displayGroupsAuto,displayGroupsManual]);


    // Marcar y/o desmarcar todos los grupos de la lista
    
    function MarcarTodosGroups() {
        if (textoBotonGroups === 'Marcar todos') {
            setTextoBotonGroups('Desmarcar todos');
            cambiarTodoGroups(true);
        } else {
            setTextoBotonGroups('Marcar todos');
            cambiarTodoGroups(false);
        }
    };

    const cambiarTodoGroups = (value) => {
        for (let i = 0; i < Groups.length; i++) {
            document.getElementById(Groups[i].id + CT.length+INV.length+TCU.length+NCU.length).checked = value;
        }
        actualizarStringGroups();
    };

    // Actualizar string de la consulta a la API según qué grupos están marcados
    const actualizarStringGroups = () => {
        var str = '';

        for (let i = 0; i < Groups.length; i++) {
            if (document.getElementById(Groups[i].id + CT.length+INV.length+TCU.length+NCU.length).checked === true) {
                str += Groups[i].id + ',';
            }
        }
        str = str.slice(0, -1);
        setListaGroups(str);

    };




    // ///////////////////////////////////////////////////////////////////////// return ////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        
            <div className='container-fluid container-comandos mp0'>
                 {/* -------------------------------------------- CT ------------------------------------------------------- */}
                <div className='row mp0' id='div-commands-ct' >
                    <div className='col-12 mp0' >
                        <div className='row' style={{ marginTop: '1%' }}>
                            <div className='col-auto'>
                                <h3>T</h3>
                            </div>
                            <div className='col-auto'>
                                <button type="button" id='mark-all-button-ct' className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={MarcarTodosCT}>{textoBotonCT}</button>
                            </div>
                        </div>
                        <div className='row mp0' id='div-row-ct-commands'>
                            {htmlCT}
                        </div>
                    </div>
                </div>
                {/* -------------------------------------------- INV ------------------------------------------------------- */}
                <div className='row mp0' id='div-commands-inv' >
                    <div className='col-12 mp0'>
                       <div className='row' style={{ marginTop: '25px' }}>
                            <div className='col-auto'>
                                <h3>INV</h3>
                            </div>
                            {htmlBotonesINV}
                            <div className='col-auto'>
                                <button type="button" id='mark-all-button-inv' className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={MarcarTodosINV}>{textoBotonINV}</button>
                            </div>
                        </div>
                        <div className='row' id='div-row-inv-commands'>
                            {htmlINV}
                        </div>
                    </div>
                </div>
                     {/* -------------------------------------------- NCU ------------------------------------------------------- */}
                <div className='row mp0' id='div-commands-ncu' style={{display:displayNCU}}>
                    <div className='col-12 mp0'>
                       <div className='row' style={{ marginTop: '25px' }}>
                            <div className='col-auto'>
                                <h3>NCU</h3>
                            </div>
                            {htmlBotonesNCU}
                            <div className='col-auto'>
                                <button type="button" id='mark-all-button-inv' className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={MarcarTodosNCU} >{textoBotonNCU}</button>
                            </div>
                        </div>
                        <div className='row' id='div-row-ncu-commands' style={{ marginTop: '10px' }}>
                            {htmlNCU}
                        </div>
                    </div>
                </div>  
                    {/* -------------------------------------------- NCU GROUPS ------------------------------------------------------- */}
                <div className='row mp0' id='div-commands-ncu-groups' style={{display:displayGroups}}>    
                    <div className='col-12 mp0'>
                        <div className='row' style={{ marginTop: '25px' }}>
                            <div className='col-auto'>
                                <h3>NCU GRUPOS</h3>
                            </div>
                            {htmlBotonesGroups}
                            <div className='col-auto'>
                                <button type="button" id='mark-all-button-inv' className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={MarcarTodosGroups} >{textoBotonGroups}</button>
                            </div>
                        </div>
                        <div className='row' id='div-row-ncu-groups-commands' style={{ marginTop: '10px' }}>
                            {htmlGroups}
                        </div>
                    </div>
                </div>
                     {/* -------------------------------------------- TCU ------------------------------------------------------- */}
                <div className='row mp0'  id='div-commands-tcu' style={{display:displayTCU}}>
                    <div className='col-12 mp0'>
                        <div className='row' style={{ marginTop: '25px' }}>
                            <div className='col-auto'>
                                <h3>TCU</h3>
                            </div>
                            {htmlBotonesTCU}
                            <div className='col-auto'>
                                <button type="button" id='mark-all-button-inv' className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={MarcarTodosTCU} >{textoBotonTCU}</button>
                            </div>
                        </div>
                        <div className='row' id='div-row-tcu-commands' style={{ marginTop: '10px' }}>
                            {htmlTCU}
                        </div>
                    </div>
                </div>
                <Modal centered show={abrirModal} onHide={() => setAbrirModal(false)} backdrop="static" aria-labelledby="reset_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConfirmacionGeneral comando={comandoEnviado} dispositivo={enviarDevice} cerrarModal={childToParent} ids={enviarLista} />
                </Modal.Body>
                </Modal>

                <Modal centered show={abrirModalPers} onHide={() => setAbrirModalPers(false)} backdrop="static" aria-labelledby="reset_modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Grados manuales</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ModalPersonalizadoGeneral comando={comandoEnviado} dispositivo={enviarDevice} cerrarModal={childToParentPers} ids={enviarLista} />
                    </Modal.Body>
                </Modal>
            </div>
    )
}

export default Comandos